import React,{Component} from 'react'
// import _ from 'lodash'

import {
  Hidden
} from 'material-ui'
import {BarChart, Bar, XAxis, YAxis, Tooltip, Legend} from 'recharts';

import SkeletonCard from './SkeletonCard'

import {
  Accent,
  Primary,
  Purple,
} from '../helper/consts'

// const data = [
//       {job: 'Page A', invites: 4000, applications: 2400, endorsements: 2400},
//       {job: 'Page B', invites: 3000, applications: 1398, endorsements: 2210},
//       {job: 'Page C', invites: 2000, applications: 9800, endorsements: 2290},
//       {job: 'Page D', invites: 2780, applications: 3908, endorsements: 2000},
//       {job: 'Page E', invites: 1890, applications: 4800, endorsements: 2181},
//       {job: 'Page F', invites: 2390, applications: 3800, endorsements: 2500},
//       {job: 'Page G', invites: 3490, applications: 4300, endorsements: 2100},
// ];

export default class AdminSummaryBarChart extends Component{
  constructor(props){
    super(props)

    this.state = {
      loading:true,
    }
  }

  componentDidMount(){
    let {data} = this.props;
    let formatted = [];
    Object.keys(data).forEach(jid=>{
      let job = data[jid];
      let obj = {};
      obj.job = `${job.title}`
      if(!!job.invites){
        obj[`Invites`] = job.invites;
      }
      else{
        obj[`Invites`] = 0;
      }
      if(!!job.applications){
        obj[`Applications`] = Object.keys(job.applications).length;
      }
      else{
        obj[`Applications`] = 0;
      }
      if(!!job.selections){
        obj[`Screened`] = Object.keys(job.selections).length;
      }
      else{
        obj[`Screened`] = 0;
      }
      formatted.push(obj)
      this.setState({
        data:formatted,
        loading:false,
      })
      // let test = _.size(job.endorsements);
      // if(!!job.endorsements && Object.keys(job.endorsements).length!==0){
      //   let endorsementsNum = 0;
      //   let counter = Object.keys(job.endorsements).length;
      //   if(counter===0){
      //     obj[`Endorsements`] = endorsementsNum;
      //     formatted.push(obj)
      //     this.setState({
      //       data:formatted,
      //       loading:false,
      //     })
      //   }
      //   Object.keys(job.endorsements).forEach(uid=>{
      //     counter--;
      //     endorsementsNum+=(Object.keys(job.endorsements[uid]))
      //     if(counter===0){
      //       obj.endorsements = endorsementsNum;
      //       formatted.push(obj)
      //       this.setState({
      //         data:formatted,
      //         loading:false,
      //       })
      //     }
      //   })
      // }
    })
  }

  render () {
    const {data} = this.state;
    return (
      this.state.loading ?
        <SkeletonCard contents={true} />
      :
        <div>
          <Hidden xsDown>
            <BarChart
              width={450}
              height={300}
              data={data}
            >
              <XAxis dataKey="job"/>
              <YAxis/>
              <Tooltip/>
              <Legend />
              <Bar stackId="a" dataKey="Invites" fill={Primary} />
              <Bar stackId="a" dataKey="Applications" fill={Accent} />
              <Bar stackId="a" dataKey="Screened" fill={Purple} />
            </BarChart>
          </Hidden>
          <Hidden smUp>
            <BarChart
              width={288}
              height={200}
              data={data}
            >
              <XAxis dataKey="job"/>
              <YAxis/>
              <Tooltip />
              <Legend />
              <Bar stackId="a" dataKey="Invites" fill={Primary} />
              <Bar stackId="a" dataKey="Applications" fill={Accent} />
              <Bar stackId="a" dataKey="Screened" fill={Purple} />
            </BarChart>
          </Hidden>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AdminSummaryBarChart.js